var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 6.25001H3.75L7.8625 2.13751C7.97966 2.02131 8.07265 1.88306 8.13612 1.73074C8.19958 1.57841 8.23225 1.41503 8.23225 1.25001C8.23225 1.085 8.19958 0.921617 8.13612 0.769293C8.07265 0.616969 7.97966 0.478718 7.8625 0.362514C7.6283 0.1297 7.31148 -0.000976562 6.98125 -0.000976562C6.65102 -0.000976562 6.3342 0.1297 6.1 0.362514L0.7375 5.73751C0.268015 6.2042 0.00279099 6.83804 0 7.50001C0.00608323 8.15765 0.271056 8.78639 0.7375 9.25001L6.1 14.625C6.21655 14.7407 6.35475 14.8324 6.50671 14.8947C6.65868 14.957 6.82143 14.9888 6.98567 14.9882C7.14991 14.9876 7.31244 14.9547 7.46395 14.8913C7.61547 14.8279 7.75302 14.7353 7.86875 14.6188C7.98448 14.5022 8.07612 14.364 8.13843 14.2121C8.20075 14.0601 8.23253 13.8973 8.23195 13.7331C8.23137 13.5688 8.19844 13.4063 8.13505 13.2548C8.07166 13.1033 7.97905 12.9657 7.8625 12.85L3.75 8.75001H16.25C16.5815 8.75001 16.8995 8.61832 17.1339 8.3839C17.3683 8.14948 17.5 7.83153 17.5 7.50001C17.5 7.16849 17.3683 6.85055 17.1339 6.61613C16.8995 6.38171 16.5815 6.25001 16.25 6.25001Z",
    fill: "#6280E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.f1e3253a0767ba3ae9af4f0e7df2d158.svg";
export { ForwardRef as ReactComponent };